import React from 'react';
import { Chip, useTheme } from '@mui/material';
import { Subscription } from '../hooks/useMarketplaceSubscriptions';
import SubscriptionHelper from '../SubscriptionHelper';

interface Props {
    subscription: Subscription;
}

export default function StatusChip({ subscription }: Props) {
    const theme = useTheme();
    const statusLabel = SubscriptionHelper.getStatusLabel(subscription);
    const statusColor = SubscriptionHelper.getChipColor(subscription, theme);

    return (
        <Chip
            label={statusLabel}
            size="medium"
            sx={{
                fontSize: '12px',
                fontStyle: 'normal',
                fontWeight: 700,
                lineHeight: '266%',
                letterSpacing: '1px',
                textTransform: 'uppercase',
                height: '24px',
                marginBottom: 1,
                ...statusColor
            }}
        />
    );
}
